const BingKey = () => {
    return process.env.REACT_APP_BING_KEY;
};

export default BingKey;